import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { FieldStateService } from "../../field-state.service";

@Injectable()
export class TextfieldStateService extends FieldStateService {
    public stateObservable$: BehaviorSubject<any>;

    constructor() {
        super();
    }

    public dispatchFieldLoad(payload): void {
        this.stateObservable$.next(super.newState({ value: payload, selectedFieldValue: payload }));
    }

    public dispatchFieldUpdate(payload): void {
        this.dispatchFieldLoad(payload);
    }
}
